import { BaseChart } from "../base/base-chart";

import { Factory } from "../../core/factory";

import { CommonChartSpecTransformer } from "./common-transformer";

import { StackChartMixin } from "../stack";

import { mixin } from "@visactor/vutils";

import { registerDimensionHover } from "../../interaction/triggers/dimension-hover";

import { registerDimensionEvents } from "../../event/events";

import { getCartesianDimensionInfo, getDimensionInfoByValue } from "../../event/events/dimension/util/cartesian";

import { getPolarDimensionInfo } from "../../event/events/dimension/util/polar";

import { getCartesianCrosshairRect } from "../../component/crosshair/utils/cartesian";

import { registerDimensionTooltipProcessor } from "../../component/tooltip/processor/dimension-tooltip";

import { registerMarkTooltipProcessor } from "../../component/tooltip/processor/mark-tooltip";

import { registerGroupTooltipProcessor } from "../../component/tooltip/processor/group-tooltip";

export class CommonChart extends BaseChart {
    constructor() {
        super(...arguments), this.transformerConstructor = CommonChartSpecTransformer, this.type = "common";
    }
    _setModelOption() {
        this._modelOption.getDimensionInfo = (chart, point, isTooltip) => {
            var _a, _b;
            return [ ...null !== (_a = getCartesianDimensionInfo(chart, point, isTooltip)) && void 0 !== _a ? _a : [], ...null !== (_b = getPolarDimensionInfo(chart, point)) && void 0 !== _b ? _b : [] ];
        }, this._modelOption.getDimensionInfoByValue = getDimensionInfoByValue, this._modelOption.getRectByDimensionData = getCartesianCrosshairRect;
    }
}

CommonChart.type = "common", CommonChart.transformerConstructor = CommonChartSpecTransformer, 
mixin(CommonChart, StackChartMixin);

export const registerCommonChart = () => {
    registerDimensionTooltipProcessor(), registerMarkTooltipProcessor(), registerGroupTooltipProcessor(), 
    registerDimensionEvents(), Factory.registerChart(CommonChart.type, CommonChart), 
    registerDimensionHover();
};
//# sourceMappingURL=common.js.map
